<template>
  <div>
    <div class="card">
      <div class="project card-header">
        <h4>{{ item.name }}</h4>
        <p><b>{{ item.date }}</b></p>
        <p>{{ item.desc }}</p>
        <div class="card-header-edit" v-on:click.stop="projectEditPressed">
          <i class="fas fa-ellipsis-v"></i>
        </div>
      </div>
      <div class="project card-body">
        <p>{{ this.item.hours }} std.</p>
      </div>
    </div>

    <!-- EDIT CUSTOMER MODAL -->
    <div class="col-md-4">
      <modal :show.sync="modals.editProject"
             body-classes="p-0"
             modal-classes="modal-dialog-centered modal-sm">
        <card body-classes="px-lg-5 py-lg-5" class="border-0"
              header-classes="bg-white pb-5"
              shadow
              type="secondary">
          <template>
            <div class="text-center text-muted mb-4">
              <h3>{{ this.item.name }}</h3>
              <small>Kunden bearbeiten</small>
            </div>
            <form role="form">
              <base-input addon-left-icon="ni ni-single-02" alternative class="mb-3" placeholder="Name"
                          v-model="editProject.name">
              </base-input>

              <base-checkbox class="mb-3" v-model="editProject.billed">
                Abgerechnet
              </base-checkbox>
              <div class="row">
                <div class="col">
                  <base-button @click.stop="removeProjectPressed" block class="my-4" type="danger">Löschen
                  </base-button>
                </div>
                <div class="col">
                  <base-button @click="updateProject" block class="my-4" type="primary">Speichern</base-button>
                </div>
              </div>
            </form>
          </template>
        </card>
      </modal>
    </div>

    <!-- REMOVE PROJECT MODAL -->
    <div class="col-md-4">
      <modal :show.sync="modals.removeProject"
             gradient="danger"
             modal-classes="modal-danger modal-dialog-centered">

        <div class="py-3 text-center">
          <i class="ni ni-bell-55 ni-3x"></i>
          <h4 class="heading mt-4">Studio wirklich löschen?</h4>
          <p>Wenn Sie das Studio löschen kann es und die darin angelegten Kunden sowie Projekte nicht wiederhergestellt
            werden.</p>
        </div>

        <template slot="footer">
          <base-button @click="removeProject()" type="white">Ok, Löschen</base-button>
          <base-button @click="modals.removeCustomer = false"
                       class="ml-auto"
                       text-color="white"
                       type="link">
            Schließen
          </base-button>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
  import firebase from "firebase";

  require('firebase/firestore');

  export default {
    name: "BilledProjectsListItem",
    data() {
      return {
        modals: {
          editProject: false,
          removeProject: false
        },
        editProject: {
          name: '',
          billed: true,
        }
      }
    },
    props: {
      item: {
        id: String,
        name: String,
        hours: Boolean,
      }
    },
    methods: {
      projectEditPressed() {
        this.modals.editProject = true
      },
      removeProjectPressed() {
        this.modals.removeProject = true
      },
      removeProject() {
        firebase.firestore().collection("projects").doc(this.item.id).delete().then(function () {
        }).catch(function (error) {
          // eslint-disable-next-line no-console
          console.error("Error removing document: ", error);
        });
      },
      updateProject() {
        const projectRef = firebase.firestore().collection("projects").doc(this.item.id);
        return projectRef.update({
          title: this.editProject.name,
          billed: this.editProject.billed
        })
          .then(() => {
            this.modals.editProject = false
          })
          .catch(function (error) {
            // eslint-disable-next-line no-console
            console.error("Error updating document: ", error);
          });
      }
    },
    created() {
      this.editProject.name = this.item.name
      this.editProject.billed = this.item.billed
    }
  }
</script>

<style scoped>
  .card {
    cursor: pointer;
    padding: 0;
    background-color: #FFFFFF;
    border-radius: 5px;
    transition: all 0.3s ease-in-out;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  }

  .card:hover {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  }

  .project.card-header {
    background-color: #fff;
    border: none;
    padding: 1rem;
  }

  .project.card-body {
    background-color: #000000;
    border-radius: 0 0 5px 5px;
    padding: .5rem;
  }

  .project.card-header > h4 {
    margin: 0;
    color: #ec407a;
    text-transform: uppercase;
  }

  .project.card-header > p {
    margin: 0;
  }

  .project.card-body > p {
    text-align: center;
    color: #fff;
    margin: 0
  }

  .card-header-edit {
    position: absolute;
    top: 0;
    right: 0;
    padding: 10px 15px;
    color: #000000;
  }
</style>
